if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

// SLICK DEFAULTS
const prevArrow = `<button type="button" class="slick-prev"><span>Prev</span><svg width="10" height="20" viewBox="0 0 10 20" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M 9 1 L 1 10 L 9 19" /></svg></button>`;
const nextArrow = `<button type="button" class="slick-next"><span>Next</span><svg width="10" height="20" viewBox="0 0 10 20" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M 1 1 L 9 10 L 1 19" /></svg></button>`;
const slickOps = {
    accessibility: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow
};

// Slick Slider with current slide number
const setSlickShowIndex = ( selector = '[data-slick_showIndex]' ) => {
    $(selector).each((i, el) => {
        let currentIndex = '01';
        $(el).on('init', (e, s)=> {
            if ( s.options.dots ) {
                $(s.options.appendDots).append(`<div class="slick-current_index"><svg width="45" height="1" viewBox="0 0 45 1" fill="none" stroke="currentColor" stroke-width="1" preserveAspectRatio="none" vector-effect="non-scaling-stroke"><path d="M 0 0.5 H 45" pathLength="1" /></svg><span>${currentIndex}</span></div>`);
            }
            if( s.options.autoplay ) {
                $('.slick-current_index svg', s.options.appendDots).css('animation-duration', `${ s.options.autoplaySpeed / 1000 }s`);
                $('.slick-current_index', s.options.appendDots).addClass('inprogress');
            }
        });
        $(el).on('beforeChange', (e, s, c, n)=> {
            currentIndex = (`0${(n+1)}`).slice(-2);
            if ( s.options.dots ) {
                $('.slick-current_index span', s.options.appendDots).text(currentIndex);
            }
            if( s.options.autoplay ) {
                $('.slick-current_index', s.options.appendDots).removeClass('inprogress');
                setTimeout(() => $('.slick-current_index', s.options.appendDots).addClass('inprogress'), 10);
            }
        });
    });
};

// ANIMATE SCROLL TOP TO ELEMENT POSITION
const goto = ( elementID ) => {
    const targetTop = document.getElementById( elementID ) ? document.getElementById( elementID ).offsetTop : 0;
    const headerHeight = document.getElementById('header') ? document.getElementById('header').offsetHeight : 0;
    
    scrollTo({ top: targetTop - headerHeight, left: 0, behavior: 'smooth' });
};

const wrapQuads = ( wrapperClass = 'wrapBG', quadsIDlist = [] ) => {
    const wrapperDOM = document.createElement('div');
    wrapperDOM.classList.add(wrapperClass);
    
    quadsIDlist.forEach( ( id, i ) => {
        const currentQuad = document.getElementById( id );
        
        if ( currentQuad ) {
            if ( i < 1 ) currentQuad.insertAdjacentElement('beforebegin', wrapperDOM);
            wrapperDOM.appendChild( currentQuad );
        }
    });
};

(function(){
    // CUSTOM SELECT
    document.querySelectorAll('[data-custom_select]').forEach(select => {
        const currentField = select.querySelector('input');

        if ( currentField ) {
            currentField.addEventListener( 'click', () => select.classList.add('active') );
        }

        select.querySelectorAll('li').forEach(li => {
            li.addEventListener('click', () => {
                if ( currentField ) {
                    currentField.value = li.dataset.value;
                }

				select.querySelectorAll('li').forEach( l => l.classList.remove('active') );
				li.classList.add('active');

                select.classList.remove('active');
            });
        });
    });

    $('.tags-press li').click(function(){
        const thisTag = $(this).attr('data-tag');
        $('.press__item').hide();
        $(`.tag-${thisTag}`).fadeIn();
        $('.tags-menu li').removeClass('active');
        $(this).addClass('active');
    });

    //filter function
    $('.press__item').addClass('active');

    //for desktop
    $("#press__filter li").click(function () {
        const thisTag = $(this).attr('data-tag');
        $(".gridder-close").click();
        $('.press__item').removeClass('active');
        $('.press__item.' + thisTag).addClass('active');
        $('.press__filter--item').removeClass('active');
        $('.press__filter--item.' + thisTag).addClass('active');
    });

    //for mobile
    $("#press__filter").change(function () {
        const this_tag = $(this).val();
        $(".gridder-close").click();
        $('.press__item').removeClass('active');
        $('.press__item.' + this_tag).addClass('active');
        $('.press__filter--item.' + thisTag).addClass('active');
    });

    // TOGGLE TARGET 'visible' CLASS ON CLICK
    document.querySelectorAll('[data-slidetarget]').forEach( (btn, i) => {
        const target  = document.querySelector( btn.getAttribute('href') );

        if ( target ) {
            btn.addEventListener('click', e => {
                e.preventDefault();
                target.classList.toggle('visible');
                if ( target.classList.contains('visible') ) goto( btn.getAttribute('href').replace('#', '') );
            });

            // USE URL HASH TO OPEN TARGET
            const match_conditions = !btn.classList.contains('hiddenForm_close') && i === 0 && (window.location.hash === btn.getAttribute('href'));
            if( match_conditions ) btn.click();
        }

    });


    // SPLIT TEXT INTO WORDS AND WRAP EACH ONE INTO SPAN
    if ( window.innerWidth > 767 ) {
        document.querySelectorAll('[data-splitwords]').forEach(mod => {
            //SAFARI LOOKBEHING NOT WORKING
            // const noHTMLwordRegex  = /((?<!<[^>]*)[a-zA-Z0-9\-\_\']+)/g;
            // const initialHTML = mod.innerHTML;
            // mod.innerHTML = initialHTML.replace(noHTMLwordRegex, '<span data-word>$1</span>');

            const initialHTML = mod.innerHTML;
            const words = mod.textContent.trim().split(' ');
            const wrappedWords = words.map(word => `<span data-word>${word}</span>`);
            let updatedHTML = initialHTML;

            words.forEach( (word, i) => updatedHTML = updatedHTML.replace(word, wrappedWords[i]) );

            mod.innerHTML = updatedHTML;
        });
    }


	// ACCORDION TOGGLE
	document.querySelectorAll('.accordion').forEach(accordion => {
		accordion.querySelectorAll('.accordion_head').forEach(itemHead => {
			itemHead.addEventListener('click', e => {
				accordion.querySelectorAll('.accordion_item').forEach(item => {
					if (itemHead.parentNode !== item) item.classList.remove('active');
				});
				itemHead.parentNode.classList.toggle('active');
			});
		});
	});

    // WRAP MODULE TABLES
    document.querySelectorAll('.tableModule table').forEach(table => {
        const tableWrapper = document.createElement('div');
        tableWrapper.classList.add('tableModule_wrap');
        table.parentNode.insertBefore(tableWrapper, table);
        tableWrapper.appendChild(table);
    });

    // HOME WRAP BG QUADS
    if ( document.body.id === 'home' ) {
        wrapQuads('homeWrapBG', [
            'topReasons-_gqvnhjpqg',
            'heroQuad-_n5hxe9ye2'
        ]);
    }

    // DINING WRAP BG QUADS
    if ( document.body.classList.contains('page-68621') ) {
        wrapQuads('diningWrapBG1', [
            'heroQuad-_a6h5fsmlr',
            'quad2pic-_2e4dd4c5l'
        ]);
    }


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    // Slick Slider with current slide number
    setSlickShowIndex();

    $('.sym-slides').slick( slickOps );

    $('[data-slick-prev]').click(function () {
        const $curSlider = $(this).data('target') ? $( $(this).data('target') ) : $(this).closest('.sym-slides');
        $curSlider.slick('slickPrev');
    });

    $('[data-slick-next]').click(function () {
        const $curSlider = $(this).data('target') ? $( $(this).data('target') ) : $(this).closest('.sym-slides');
        $curSlider.slick('slickNext');
    });

    $('[data-slick-goto]').click(function () {
        const $curSlider = $(this).data('target') ? $( $(this).data('target') ) : $(this).closest('.sym-slides');
        const target = $(this).data('slick-goto') ? parseInt( $(this).data('slick-goto') ) : 0;

        $curSlider.slick('slickGoTo', target);
        $(this).siblings('[data-slick-goto]').removeClass('active');
        $(this).addClass('active');
    });

})();